import RespetoValoresPrincipios from '../domain/RespetoValoresPrincipios'
import RespetoValoresPrincipiosDto from '../domain/RespetoValoresPrincipiosDto'

export default class CreateRespetoValoresPrincipios {
  #repository

  constructor(repository) {
    this.#repository = repository
  }

  async execute(evaluacionDesempenioAcademico, idPersonal) {
    const catalogoReactivos = await this.#repository.getEvaluationItems()
    const dto = RespetoValoresPrincipiosDto.create(evaluacionDesempenioAcademico, catalogoReactivos)
    const { data } = await this.#repository.create(dto, idPersonal)

    return data[0].ID
  }
}
